module.exports = __webpack_public_path__ + "media/images/icon_delete-17483e9b7c69aacd4c4c7a891330b4cd.png";